export const IN_REVIEW_CREDITS_TITLE = 'Credits - In Review';
export const RFI_REQUESTED_CREDITS_TITLE = 'Credit - RFI Requested';

export const UNMAPPED_CREDITS_TITLE = 'Unmapped Credits';

export const CREDIT_TRANSACTION_LIMIT = 10;

export const CREDIT_TRANSACTION_TABLE_HEADINGS = [
  'Date',
  'Transaction ID',
  'Amount',
  'Currency',
  'Beneficiary Name',
  'Beneficiary Account No.',
  'Source Account Address',
  'Tranfer Method',
  'Transfer Type',
  'Status',
];

export const CREDIT_TRANSACTION_STATUSES = {
  IN_REVIEW: 'in_review',
  UNMAPPED: 'unmapped',
  RFI_REQUESTED: 'rfi_requested',
};

export const STATUS_COLORS = {
  succeeded: 'green',
  failed: 'red',
  in_review: 'yellow',
  unknown: 'gray',
  active: 'green',
  delayed: 'orange',
  unmapped: 'gray',
  rfi_requested: 'purple',
  failed_due_to_compliance: 'red',
};

export const ACTION_TYPES = {
  WHITELIST: 'whitelist',
  CHAINALYSIS: 'chainalysis',
};

export const ACTIONS = {
  APPROVE: 'approve',
  REJECT: 'reject',
  MANUAL_REFUND: 'manual_refund',
};

export const TRANSACTION_TYPE_CREDIT = 'credit';
export const TRANSFER_METHOD_CRYPTO = 'CRYPTO';
export const TRANSFER_METHOD_FIAT = 'FIAT';

export const CREDIT_TXN_TAB_CONFIG = [
  {
    title: IN_REVIEW_CREDITS_TITLE,
    status: CREDIT_TRANSACTION_STATUSES.IN_REVIEW,
  },
  {
    title: RFI_REQUESTED_CREDITS_TITLE,
    status: CREDIT_TRANSACTION_STATUSES.RFI_REQUESTED,
  },
];

export const SCREENING_STATUS_TAB_CONFIG = [
  {
    title: 'KYC',
    screening_status: 'KYC',
  },
  {
    title: 'KYT',
    screening_status: 'KYT',
  },
  {
    title: 'WHITELIST',
    screening_status: 'WHITELIST',
  },
];
